
import { defineComponent, onMounted, ref, watch } from 'vue';
export default defineComponent({
  name: 'InlineEditField',
  emits: ['cancel', 'save', 'edit'],
  props: {
    isEditable: {
      type: Boolean,
      default: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isEditing = ref<boolean>(false);

    const toggleEditMode = () => {
      if (!props.isEditable) return;

      isEditing.value = !isEditing.value;
    };

    const onCancel = () => {
      isEditing.value = false;
      emit('cancel');
    };
    const onSave = () => {
      isEditing.value = false;
      emit('save');
    };

    watch(isEditing, () => {
      if (isEditing.value) {
        emit('edit');
      }
    });

    onMounted(() => {
      if (props.editing) {
        isEditing.value = props.editing;
      }
    });

    return {
      isEditing,
      toggleEditMode,
      onCancel,
      onSave,
    };
  },
});
